'use client';

import { Switch as MuiSwitch, SwitchProps } from '@mui/material';

import styles from './Switch.module.scss';

const Switch = (props: SwitchProps) => (
  <MuiSwitch
    {...props}
    classes={{
      root: styles.root,
      switchBase: styles.switchBase,
      thumb: styles.thumb,
      track: styles.track,
      checked: styles.checked,
      disabled: styles.disabled,
    }}
  />
);

export default Switch;
